import React from 'react'

import Aux from 'hoc/ReactAux/ReactAux'
import logo from '../../../img/logo-lunch-team.svg'
import './GDPRModal.scss'
import ReactModal from 'react-modal'

const customStyles = {
  content: {
    background : 'none',
    border: 'none',
  },
  overlay : {
    zIndex                   : '9999999',
    width                    : '100%',
    height                   : '100%',
    left                     : '0',
    top                      : '0',
    backgroundColor         : 'rgba(0, 0, 0, 0.7)'
  }
}

const GdprModal = (props) =>{
  if(!props.show)
    return null

  return (
    <Aux>
      <ReactModal
          isOpen={props.show}
          style={customStyles}
          onRequestClose={props.clickButtonDeny}
          shouldCloseOnOverlayClick={true}
          contentLabel="Example Modal">
          <div style={props.style}
               className="gdpr-modal">
            <button onClick={props.closeModal}
                    title="Close (Esc)"
                    type="button"
                    className="mfp-close lb-fechar fa fa-times">
            </button>
              <img src={logo} alt="Lunch Team" />
                <h3><strong>{props.isTermsConditions ? 'Terms & Conditions' : 'Privacy Policy' }</strong></h3>
                <div className="content gdpr-content-modal" >
                  <div style={{display : props.isTermsConditions ? 'show' : 'none' }}
                       dangerouslySetInnerHTML={{ __html: props.termsConditions }} />
                  <div style={{display : !props.isTermsConditions ? 'show' : 'none' }}
                       dangerouslySetInnerHTML={{ __html: props.privacyPolicy }} />
                </div>
          </div>
      </ReactModal>
    </Aux>
  )
}

export default GdprModal



// WEBPACK FOOTER //
// ./src/containers/GDPR/GDPRModal/index.js